import Popup from './popup';

export default function Logout () {
    const triggers = [...document.querySelectorAll('#desktop-logout-trigger, #mobile-logout-trigger, #dashboard-logout-trigger')];

    const popup = new Popup({
        popup: '.site-popup[data-popup="account-logout"]',
        toggle: null,
        close: '.site-popup-close[data-popup="account-logout"]',
        window: '.site-popup-window[data-popup="account-logout"]'
    });

    const close = document.querySelector('.site-popup[data-popup="account-logout"] .site-button.passive');

    triggers.forEach((trigger) => {
        if (!trigger) return;

        trigger.addEventListener('click', (event) => {
            event.stopPropagation();
            event.preventDefault();

            popup.open();
        });
    });

    close.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        popup.close.click();
    });
}
